export default __webpack_public_path__ + "static/Lend-Stablecoins-a4b4d18910ffb0b238e5b814264d916d.svg";